<template>
  <div id="hpv" class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="select-situacao info-table-item">
          <vue-select
            :options="filterIdadeOptions"
            label="label"
            placeholder="Idade"
            v-model="filterIdade"
            @input="filtros(exibirCadastrosVermelhos, exibirCadastrosVerdes)"
            :clearable="true"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="cadastrosParaXls"
            :fields="dataFields"
            name="hpv-quadrivalente"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'

export default {
  name: 'HpvQuadrivalente',
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
    SelectsV2,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      loading: false,
      cadastrosOriginais: [],
      cadastros: [],
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      disabledRed: false,
      disabledGreen: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
      micro_area: '',
      filterIdadeOptions: [...Functions.filterIdadeOptions],
      filterIdade: { label: '9 - 14 anos', value: '9 - 14 anos' },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    cadastrosParaXls() {
      return Functions.formatarCadastrosComDoses(this.cadastros).map(
        (item, index) => ({
          index: index,
          ...item,
        })
      )
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Aplica o filtro de exibição de cadastros (vermelhos ou verdes).
     * @param {Boolean} vermelho Indica se o filtro de vermelhos deve ser aplicado
     * @param {Boolean} verde Indica se o filtro de verdes deve ser aplicado
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (this.filterIdade !== null) {
        data = Functions.handleFilterIdade(data, this.filterIdade.value)
      }

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      setTimeout(() => {
        if (event == true) {
          // mostra os vermelhos
          this.filtros(true, false)
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVermelhos = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      setTimeout(() => {
        if (event == true) {
          // mostra os verdes
          this.filtros(false, true)
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
        } else {
          this.filtros(false, false)
          this.exibirCadastrosVerdes = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) this.$refs.table.search = ''

      this.equipe = event
      this.micro_area = ''

      if (event) {
        this.resetCadastros()
        await this.buscarCadastrosPorEquipe()
      } else {
        this.resetCadastros()
      }
    },

    /**
     * Busca os cadastros de uma equipe
     */
    async buscarCadastrosPorEquipe() {
      this.loading = true
      const resposta = await Functions.getDadosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
        this.setRed = true
      }
      this.loading = false
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.tabsActive = 0
      this.micro_area = event?.micro_area || ''
      if (event && this.micro_area) {
        this.loading = true
        await this.buscarCadastrosMicroArea()
        this.loading = false
      } else {
        await this.onChangeEquipe(this.equipe)
      }
    },

    /**
     * Buscar dados por microárea
     */
    async buscarCadastrosMicroArea() {
      this.loading = true
      const resposta = await Functions.getDadosPorMicroarea(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap,
        this.micro_area
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
        this.setRed = true
      }
      this.loading = false
    },

    /**
     * Resetar dados
     */
    resetCadastros() {
      this.cadastros = []
      this.cadastrosOriginais = []
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area
      )
    },

    /**
     * Inicializa os dados
     */
    async init() {
      try {
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.buscarCadastrosPorEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
          }
          this.micro_area = this.$store.state.micro_area
          this.buscarCadastrosMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style></style>
